// removed by extract-text-webpack-plugin
module.exports = {"content":"Subscribe__content--33RUf","text":"Subscribe__text--qni3B","subscribe":"Subscribe__subscribe--3ygSI","subscribed":"Subscribe__subscribed--1trcK Subscribe__subscribe--3ygSI","check":"Subscribe__check--2YUDd","bounce":"Subscribe__bounce--mkG0J"};


//////////////////
// WEBPACK FOOTER
// ./src/author/components/Subscribe/Subscribe.css
// module id = ./src/author/components/Subscribe/Subscribe.css
// module chunks = 1